module.exports = __webpack_public_path__ + "img/facebook.57d3f125.svg";